import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function DepositCancel() {
  return (
    <div className="min-h-screen bg-navy grain flex items-center justify-center px-5" data-testid="deposit-cancel-page">
      <div className="bg-white rounded-3xl p-10 max-w-md text-center shadow-2xl">
        <XCircle className="w-14 h-14 text-muted-foreground mx-auto mb-5" />
        <h1 className="font-heading text-2xl font-semibold text-navy mb-2">Deposit not completed</h1>
        <p className="text-muted-foreground mb-6">Your booking request is still saved — you can complete the deposit anytime, or reach out and we'll help you finish booking.</p>
        <Link to="/" className="inline-block px-7 py-3.5 rounded-full bg-leaf text-white font-medium hover:scale-105 transition-transform">Back to Home</Link>
      </div>
    </div>
  );
}
